import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';

import isEmpty from 'lodash/isEmpty';
import Markdown from '../markdown';

const styles = {
  footer: {
    backgroundColor: '#1D1E1F',
    minHeight: '285px',
    px: { xs: '24px', md: '144px' },
    py: '64px',
  },
};

const query = graphql`
  query Footer($id: StringQueryOperatorInput = {}) {
    template(id: $id) {
      caseName
      home {
        footerDisclaimer
        privacyPolicyUrl
        contactInformation {
          city
          claimAdmin
          email
          phone
          state
          street
          zipCode
        }
      }
    }
  }
`;

const Footer = () => {
  const data = useStaticQuery(query);
  const currentYear = new Date().getFullYear();

  const { footerDisclaimer, privacyPolicyUrl, contactInformation } =
    data.template.home;
  return (
    <Box sx={styles.footer}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Grid
            container
            justifyContent="space-between"
            sx={{ p: { xs: 'initial', md: 0 } }}
          >
            <Grid item xs={12}>
              <Typography
                color="white"
                sx={{
                  fontWeight: '600',
                  fontSize: '20px',
                }}
              >
                {data.template.caseName}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {footerDisclaimer && (
          <Grid item xs={12} md={4} sx={{ minminHeight: '96px' }}>
            <Box>
              <Markdown
                style={{ color: 'white', fontWeight: '400', fontSize: '14px' }}
                source={footerDisclaimer}
              />
            </Box>
          </Grid>
        )}
        {!isEmpty(contactInformation) && (
          <Grid item xs={12} md={4} sx={{ minHeight: '96px' }}>
            <Typography
              sx={{
                fontWeight: '600',
                fontSize: '14px',
              }}
              color="white"
            >
              Claim Administrator
            </Typography>
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
              }}
              color="white"
            >
              {contactInformation.claimAdmin}
            </Typography>
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
              }}
              color="white"
            >
              {contactInformation.street}
            </Typography>
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
              }}
              color="white"
            >
              {`${contactInformation.city}, ${contactInformation.state} ${contactInformation.zipCode}`}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
            }}
            color="white"
          >
            If you would like to request to have your data deleted, please{' '}
            <Link to="/contact">contact us</Link> and include the request in the
            message.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
            }}
            color="white"
          >
            {`Copyright © ${currentYear} - All Rights Reserved`}
            {' - '}
            <Link to="/privacy">Privacy&nbsp;Policy</Link>
            {' | '}
            <Link to="/faqs">FAQs</Link>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
